<template>
  <ContentLayout
    :title="$t('label_essweb_event_form_newTitle')"
    widthClass="max-1000"
    pad="0"
    :initData="eventData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'event_business_name',
      'event_business_code',
      'event_business_description',
      'start_utc_time',
      'end_utc_time',
      'event_type_uuid',
      'event_property_group_uuid',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row align="center" justify="start">
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_event_form_eventTypeLabel")
                }}</v-sheet>
                <v-autocomplete
                  :items="EventType"
                  item-text="event_type_name"
                  item-value="uuid"
                  single-line
                  @change="onTypeChange"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  v-model="eventData.event_type_uuid"
                  filled
                  :label="$t('label_essweb_event_form_eventTypeLabel')"
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  :bindData="eventData.event_business_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      eventData.event_business_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_event_form_eventNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  v-model="eventData.event_business_code"
                  maxlength="20"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="eventData.event_business_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      eventData.event_business_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_event_form_eventDescriptionLabel')"
                />
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <TimePicker
                  isRequire
                  showDay
                  :value="eventData.start_utc_time"
                  :defaultTime="eventData.start_utc_time"
                  :max="eventData.end_utc_time"
                  placeholder="00:00"
                  :label="$t('label_essweb_event_form_eventStartTimeLbel')"
                  @change="
                    (time) => {
                      eventData.start_utc_time = time;
                    }
                  "
                />
              </v-col>
              <!-- <v-col md="3" class="mt-n5">
                Time Zone
                <v-autocomplete
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                  single-line
                  v-model="eventData.start_time_time_zone"
                  dense
                  placeholder="time zone"
                  filled
                >   <template v-slot:no-data>
                <noContent />
              </template></v-autocomplete>
              </v-col>-->
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <TimePicker
                  isRequire
                  isEnd
                  showDay
                  :min="eventData.start_utc_time"
                  :value="eventData.end_utc_time"
                  :defaultTime="eventData.end_utc_time"
                  placeholder="00:00"
                  :label="$t('label_essweb_event_form_eventEndTimeLabel')"
                  @change="
                    (time) => {
                      eventData.end_utc_time = time;
                    }
                  "
                />
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12" class="mt-n5">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_event_form_timeZoneLabel")
                }}</v-sheet>
                <v-select
                  :items="staticZone"
                  item-text="text"
                  item-value="utc"
                  dense
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  single-line
                  v-model="eventData.end_time_time_zone"
                  :placeholder="$t('label_essweb_event_form_timeZoneLabel')"
                  filled
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-form ref="form2" lazy-validation>
            <v-row align="center" justify="start" class="flex-column">
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_event_form_eventPropertyGroupLabel")
                }}</v-sheet>
                <v-select
                  :items="EventGroup"
                  item-text="event_property_group_name"
                  item-value="uuid"
                  single-line
                  @change="onGroupChange"
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  v-model="eventData.event_property_group_uuid"
                  filled
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="$t('label_essweb_event_form_eventPropertyGroupLabel')"
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <PropertyList
                  :items="desserts"
                  :listdata="PropertyListData"
                  v-if="desserts.length"
                  :canEdit="false"
                  @view="
                    (obj) => {
                      viewProperty = true;
                      toEditProperty(obj);
                    }
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </template>
      </Stepper>
    </template>
    <!-- content -->

    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toAddEvent"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <EditMappingPopup2
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        :curGroupId="eventData.event_property_group_uuid"
        :view="viewProperty"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import EditMappingPopup2 from "@/Page/EssAdmin/Event/EventPropertyGroup/components/EditMappingPopup2.vue";
import { mapGetters } from "vuex";
export default {
  name: "newEvent",
  components: {
    EditMappingPopup2,
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
    EventType() {
      return this.$getSelectTrans(this.EventTypeData, "event_type_name");
    },
    EventGroup() {
      return this.$getSelectTrans(
        this.EventGroupData,
        "event_property_group_name"
      );
    },
  },
  data() {
    return {
      tab: null,
      isChanged: false,
      showPropertyDialog: false,
      PropertyListData: null,
      showMappingPopup: false,
      PropertyData: null,
      viewProperty: true,
      eventData: {
        event_business_name: "",
        event_business_code: "",
        event_business_description: "",
        start_utc_time: 0,
        start_time_time_zone: 0,
        end_utc_time: 0,
        end_time_time_zone: 0,
        event_type_uuid: "",
        event_property_group_uuid: "",
        remarks: "",
      },
      stepper: [
        "label_essweb_event_form_step_generalLabel",
        "label_essweb_event_form_step_propertyGroupLabel",
      ],
      curStep: 1,
      curTable: "",
      desserts: [],
      EventTypeData: [],
      EventGroupData: [],
    };
  },
  watch: {
    // "eventData.start_utc_time": function (val) {
    //   if (Number(val) > Number(this.eventData.end_utc_time)) {
    //     this.eventData.end_utc_time = Number(val);
    //   }
    // },
    // "eventData.end_utc_time": function () {
    //   if (Number(val) < Number(this.eventData.start_utc_time)) {
    //     this.eventData.start_utc_time = Number(val);
    //   }
    // },
  },
  mounted() {
    this.eventData.start_time_time_zone = this.defaultUTC;
    this.eventData.end_time_time_zone = this.defaultUTC;
    this.eventData.event_business_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.eventData.event_business_description = this.$getCommonLangKey(
      this.companyLang
    );
    this.getEventType();
    this.getEventGroup();
  },
  methods: {
    getPropertyList: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property",
        url: "/event-property/get-event-property-list/",
        data: {
          event_property_group_uuid: uuid,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    onTypeChange: function (type) {
      const that = this;
      if (type) {
        this.EventTypeData.forEach(function (item) {
          if (item.uuid == type) {
            that.curTable = item.table_name;
          }
        });
      }
    },
    onGroupChange: function (uuid) {
      this.getPropertyList(uuid);
    },
    getEventType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/get-event-type-list/",
        data: { event_category_uuid: "att" },
      }).then((res) => {
        res.data.map((item) => {
          if (item.table_name) {
            that.EventTypeData.push(item);
          }
        });
      });
    },
    getEventGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_property_group",
        url: "/event-property-group/get-event-property-group-list/",
      }).then((res) => {
        that.EventGroupData = res.data;
      });
    },
    toAddEvent: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (!this.$refs["form2"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let total_minutes = 0;
      if (Number(this.eventData.start_utc_time) >= 0) {
        total_minutes =
          Number(this.eventData.end_utc_time) -
          Number(this.eventData.start_utc_time);
      } else {
        total_minutes =
          Math.abs(
            parseInt(Number(this.eventData.start_utc_time) / 1440) * 1440
          ) +
          Number(this.eventData.end_utc_time) +
          Math.abs(parseInt(Number(this.eventData.start_utc_time) % 1440));
      }
      this.$Request({
        method: "POST",
        table: this.curTable,
        url: "/event/add-event-table/",
        data: {
          event_business_name: this.$transCommonLangKey(
            this.eventData.event_business_name
          ),
          event_business_description: this.$transCommonLangKey(
            this.eventData.event_business_description
          ),
          event_business_code: this.eventData.event_business_code,
          start_utc_time: this.eventData.start_utc_time,
          start_time_time_zone: this.eventData.end_time_time_zone, //sync utc
          end_utc_time: this.eventData.end_utc_time,
          end_time_time_zone: this.eventData.end_time_time_zone,
          event_type_uuid: this.eventData.event_type_uuid,
          event_property_group_uuid: this.eventData.event_property_group_uuid,
          total_minutes: total_minutes,
          remarks: this.eventData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
